import Dot from "./Dot";

export default Dot;
